import { render, staticRenderFns } from "./colorpicker_field.vue?vue&type=template&id=a0907560&lang=pug&"
import script from "./colorpicker_field.vue?vue&type=script&lang=js&"
export * from "./colorpicker_field.vue?vue&type=script&lang=js&"
import style0 from "./colorpicker_field.vue?vue&type=style&index=0&id=a0907560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports